import React from "react";
import { Sparkles } from "lucide-react";

export const ReportArchetype = ({ strategy }) => {
  const arch = strategy.brand_archetype || {};
  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-br from-emerald-900/30 to-slate-900 border border-emerald-500/30 rounded-2xl p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 bg-emerald-500 rounded-xl flex items-center justify-center">
            <Sparkles className="w-6 h-6 text-white" />
          </div>
          <div>
            <p className="text-sm text-slate-400">Primary Archetype</p>
            <h3 className="text-2xl font-bold text-white">{arch.primary_archetype || "N/A"}</h3>
          </div>
        </div>
        <p className="text-slate-300">{arch.archetype_description || ""}</p>
      </div>
      {arch.secondary_archetype && (
        <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
          <h3 className="font-semibold text-white mb-2">Secondary Archetype</h3>
          <p className="text-slate-300">{arch.secondary_archetype}</p>
        </div>
      )}
      {arch.personality_traits && (
        <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
          <h3 className="font-semibold text-white mb-4">Personality Traits</h3>
          <div className="flex flex-wrap gap-2">
            {arch.personality_traits.map((trait) => (
              <span key={`trait-${trait}`} className="px-4 py-2 bg-emerald-500/20 text-emerald-400 rounded-full text-sm font-medium">
                {trait}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
